<template>
    <div class="container-fluid">
        <div style="margin-bottom: 6px">
            <div>
                <div style="float: left; margin-top: 6px; margin-bottom: 6px">
                    <b>{{ total }}</b> Users
                </div>
                <div style="float: right; margin-top: 6px; margin-bottom: 6px">
                    <button class="btn btn-sm btn-primary" @click="addVisible = true"> New User </button>
                </div>
            </div>
            <el-table v-tb-height="{ bottom: 40, self: this }" :height="height" stripe  border :data="list" empty-text="Temporarily no data">
                <el-table-column prop="user_name" label="Name" min-width="100px"></el-table-column>
                <el-table-column prop="user_email" label="Email" min-width="200px"></el-table-column>
                <el-table-column prop="user_status" label="Status" min-width="100px">
                    <template slot-scope="scope">
                        <template v-if="scope.row.user_status == 0">
                            <div class="style1" style="background-color: red"></div>
                            <span style="margin: auto">Disable</span>
                        </template>
                        <template v-if="scope.row.user_status == 1">
                            <div class="style1" style="background-color: springgreen"></div>
                            <span style="margin: auto">Activation</span>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column prop="user_type" label="Type" min-width="100px">
                    <template slot-scope="scope">
                        <template v-if="scope.row.user_type == 0"> General User </template>
                        <template v-if="scope.row.user_type == 1"> Administrator </template>
                        <template v-if="scope.row.user_type == 2"> Craftie admin </template>
                        <template v-if="scope.row.user_type == 3"> Content admin </template>
                        <template v-if="scope.row.user_type == 4"> Device and Content admin </template>
                        <template v-if="scope.row.user_type == 5"> Search admin </template>
                        <template v-if="scope.row.user_type == 6"> Product admin </template>
                    </template>
                </el-table-column>
                <el-table-column label="Last Access" min-width="150px">
                    <template slot-scope="scope">
                        <template v-if="scope.row.last_access != 0"> {{ new Date(scope.row.last_access * 1000) }} </template>
                        <template v-else> </template>
                    </template>
                </el-table-column>
                <el-table-column min-width="150px" label="Operator">
                    <template slot-scope="scope">
                        <a v-on:click="toUpdate(scope.row)"><i class="el-icon-s-data update"></i>Update</a>
                        <a v-on:click="toDelete(scope.row)"><i class="el-icon-delete delete"></i>Delete</a>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div align="right">
            <div class="block">
                <el-pagination
                    @current-change="handleCurrentChange"
                    layout="prev, pager, next"
                    :current-page="currentPage"
                    :page-size="pageSize"
                    :total="total"
                ></el-pagination>
            </div>
        </div>
        <el-dialog
            title="Add User"
            :visible.sync="addVisible"
            :fullscreen="false"
            width="300px"
            top="10vh"
            :destroy-on-close="true"
            :show-close="true"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
        ><AdminUserAdd v-if="addVisible" @close="toClose($event)"></AdminUserAdd></el-dialog>
        <el-dialog
            title="Update User"
            :visible.sync="editVisible"
            :fullscreen="false"
            width="300px"
            top="10vh"
            :destroy-on-close="true"
            :show-close="true"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
        ><AdminUserUpdate v-if="editVisible" @close="toClose($event)"></AdminUserUpdate></el-dialog>
    </div>
</template>

<script>
import AdminUserAdd from "./AdminUserAdd";
import AdminUserUpdate from "./AdminUserUpdate";
export default {
    name: "AdminUser",
    components: { AdminUserAdd, AdminUserUpdate },
    data() {
        return {
            height: 0,
            list: [],
            search: {
                name: "",
                id: "",
            },
            chooseItem: null,
            addVisible: false,
            editVisible: false,
            dialogName: "",
            currentPage: 1,
            pageSize: 20,
            total: 0, //400
        };
    },
    created() {
        this.getData();
    },
    mounted() {},
    methods: {
        getData() {
            this.$api.rootV1.post(
                "/web/user/list",
                { page: this.currentPage, size: this.pageSize },
                (res) => {
                this.list = res.data;
                this.total = Number.parseInt(res.totalCount);
                }
            );
        },
        toUpdate(row) {
            this.$util.save("item", row);
            this.editVisible = true;
        },
        toDelete(row) {
            this.$confirm(
                "This operation will delete the user, do you want to continue?",
                "prompt",
                {
                    confirmButtonText: "Confirm",
                    cancelButtonText: "Cancel",
                    type: "warning",
                }
            ).then(async () => {
                this.doDelete(row);
            }).catch(() => {
                this.$message({
                    type: "info",
                    message: "cancelled!",
                });
            });
        },
        doDelete(row) {
            let loading = this.$util.loading();
            this.$api.rootV1.post(
                "/web/user/delete",
                { user_email: row.user_email, uid: row.uid },
                (res) => {
                    this.$message.success("successfully deleted!");
                    this.getData();
                    loading.close();
                },
                (res) => {
                    this.$message.error("failed to delete!");
                    loading.close();
                }
            );
        },
        toClose(flag) {
            this.addVisible = false;
            this.editVisible = false;
            if (flag) {
                this.getData();
            }
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getData();
        },
    },
    watch: {},
};
</script>

<style scoped>
.style1 {
    width: 15px;
    height: 15px;
    display: flex;
    float: left;
    margin-left: 5px;
    margin-top: auto;
    margin-bottom: auto;
}
</style>




// WEBPACK FOOTER //
// src/components/main/adminUser/AdminUser.vue